import { SOMETHING_WENT_WRONG_MESSAGE, TRY_UPDATE_CHANGES_AGAIN_MESSAGE, UPDATE_SUCCESS_MESSAGE } from '../../common/constants';
import { updateJobPreference, updateProfile } from '../../services/ProfileService';
import { useEffect, useState } from 'react';

import Button from '../../components/button/Button';
import Loader from '../../components/loader/Loader';
import Select from 'react-select';
import Toast from '../../components/toast/Toast';
import analytics from '../../firebase';
import { getUserInfoAndToken } from '../../common/helper';
import { logEvent } from 'firebase/analytics';

const JobPreference = ({ user, setUser, codeTableJobTypeOptions, codeTableExpectedSalaryPerOptions }) => {
    const [startWorkAnytime, setStartWorkAnytime] = useState(false);
    const [inviteToApply, setInviteToApply] = useState(false);
    const [partTime, setPartTime] = useState(false);
    const [fullTime, setFullTime] = useState(false);
    const [contract, setContract] = useState(false);
    const [expectedSalary, setExpectedSalary] = useState();
    const [selectedExpectSalaryPer, setSelectedExpectSalaryPer] = useState({});
    const [pdpa, setPdpa] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessageHeader, setErrorMessageHeader] = useState('');
    const [errorMessageDescription, setErrorMessageDescription] = useState('');
    const [enableUpdateChangesBtn, setEnableUpdateChangesBtn] = useState(false);
    const [successMessageHeader, setSuccessMessageHeader] = useState('');
    const [successMessageDescription, setSuccessMessageDescription] = useState('');

    useEffect(() => {
        const prefJobTypes = user.prefjobtypes?.split(',');

        const jobOptions = codeTableJobTypeOptions.filter((jo) => prefJobTypes?.includes(jo.codeid.toString()));
        jobOptions.forEach((jobOption) => {
            switch (jobOption.val) {
                case 'Part Time':
                    setPartTime(true);
                    break
                case 'Full Time':
                    setFullTime(true);
                    break
                case 'Contract':
                    setContract(true);
                    break
            }
        })

        setStartWorkAnytime(user.isavl === '1');
        setInviteToApply(user.prvclvl === '1');
        setPdpa(user.pdpa === '1');
        setExpectedSalary(user.expsal);

        const esp = codeTableExpectedSalaryPerOptions.filter((esp) => esp.codeid === parseInt(user.expsalp));
        if (esp.length > 0) {
            setSelectedExpectSalaryPer(esp[0]);
        }
    }, [user, setUser, codeTableJobTypeOptions, codeTableExpectedSalaryPerOptions])

    const handleStartWorkAnytimeChange = () => {
        setStartWorkAnytime(!startWorkAnytime);
        setEnableUpdateChangesBtn(true);
    }
    const handleInviteToApplyChange = () => {
        setInviteToApply(!inviteToApply);
        setEnableUpdateChangesBtn(true);
    }
    const handlePartTimeChange = () => {
        setPartTime(!partTime);
        setEnableUpdateChangesBtn(true);
    }
    const handleFullTimeChange = () => {
        setFullTime(!fullTime);
        setEnableUpdateChangesBtn(true);
    }
    const handleContractChange = () => {
        setContract(!contract);
        setEnableUpdateChangesBtn(true);
    }
    const handleExpectedSalaryChange = (e) => {
        setExpectedSalary(e.target.value);
        setEnableUpdateChangesBtn(true);
    }
    const handleExpectedSalaryPerChange = (selectedItem) => {
        setSelectedExpectSalaryPer(selectedItem);
        setEnableUpdateChangesBtn(true);
    }
    const handlePdpaChange = () => {
        setPdpa(!pdpa);
        setEnableUpdateChangesBtn(true);
    }

    const getSelectedPreferredJobTypeCodeIds = () => {
        const selectedJobOptions = [];
        if (partTime) {
            selectedJobOptions.push('Part Time');
        }
        if (fullTime) {
            selectedJobOptions.push('Full Time');
        }
        if (contract) {
            selectedJobOptions.push('Contract');
        }

        const selectedJobOptionsCodeIds = codeTableJobTypeOptions
            .filter((jo) => selectedJobOptions.includes(jo.val))
            .map((jo) => jo.codeid);
        return selectedJobOptionsCodeIds.join(',');
    }

    const getAvailibility = () => {
        let availability = '';
        if (startWorkAnytime)
            availability = 'start work anytime';
        else if (inviteToApply)
            availability = 'invite to apply';
        else if (startWorkAnytime && inviteToApply)
            availability = 'both'
        return availability;
    }
    const getSelectedPreferredJobTypes = () => {
        const selectedJobOptions = [];
        if (partTime) {
            selectedJobOptions.push('Part Time');
        }
        if (fullTime) {
            selectedJobOptions.push('Full Time');
        }
        if (contract) {
            selectedJobOptions.push('Contract');
        }
        return selectedJobOptions.join(',');
    }

    const resetSuccessMessages = () => {
        setSuccessMessageHeader('');
        setSuccessMessageDescription('');
    }

    const resetErrorMessages = () => {
        setErrorMessageHeader('');
        setErrorMessageDescription('');
    }

    const handleUpdateChanges = async () => {
        try {
            resetSuccessMessages();
            resetErrorMessages();
            setIsLoading(true);

            let updateJobPreferenceSuccessful = true;
            const updateQueryParamsForJobPreference = {
                jt: getSelectedPreferredJobTypeCodeIds(),
                sal: expectedSalary,
                salperiod: selectedExpectSalaryPer?.codeid,
            }
            const { userId, username, token } = getUserInfoAndToken();
            const updateJobPreferenceResponse = await updateJobPreference(userId, username, token, updateQueryParamsForJobPreference);
            if (updateJobPreferenceResponse?.code !== '00') {
                const messages = updateJobPreferenceResponse?.message;
                if (messages?.length > 0) {
                    setErrorMessageHeader('Update error');
                    setErrorMessageDescription(messages.join('\n'));
                }
                updateJobPreferenceSuccessful = false;
                setEnableUpdateChangesBtn(true);
            }

            if (updateJobPreferenceSuccessful) {
                const updateFormParams = {
                    fullm: user?.fullm,
                    phone: user?.mobm,
                    eml: user?.eml,
                    gender: user?.gender,
                    brthdt: user?.brthdt,
                    pdpa: pdpa ? '1' : ''
                };
                const updateQueryParams = {
                    expsal: expectedSalary,
                    expsalp: selectedExpectSalaryPer?.codeid,
                    empsts: user?.empsts,
                    edulvlc: user?.edulvlc,
                    eduyoc: user?.eduyoc,
                    dsc: user?.dsc,
                    isavl: startWorkAnytime ? '1' : '',
                    prvclvl: inviteToApply ? '1' : '2'
                };

                const updateProfileResponse = await updateProfile(userId, username, token, updateQueryParams, updateFormParams);
                if (updateProfileResponse?.code === '00') {
                    logEvent(analytics, 'profile_job_preferences_updated', { 'userid': userId, 'availability': getAvailibility(), 'employment_types': getSelectedPreferredJobTypes(), 'expected_salary': expectedSalary, 'pdpa': pdpa });
                    const data = updateProfileResponse?.data;
                    if (data?.length > 0) {
                        setUser(data[0]);
                    }

                    setSuccessMessageHeader(UPDATE_SUCCESS_MESSAGE);
                    setSuccessMessageDescription('Your changes to Job preference has been saved!');
                    setEnableUpdateChangesBtn(false);
                } else {
                    const messages = updateProfileResponse?.message;
                    if (messages?.length > 0) {
                        setErrorMessageHeader('Update error');
                        setErrorMessageDescription(messages.join('\n'));
                    }
                    setEnableUpdateChangesBtn(true);
                }
            }

            setIsLoading(false);
        } catch (error) {
            console.log(`error occurred while updating the job preferences: ${error}`);

            setIsLoading(false);
            setEnableUpdateChangesBtn(true);
            setErrorMessageHeader(SOMETHING_WENT_WRONG_MESSAGE);
            setErrorMessageDescription(TRY_UPDATE_CHANGES_AGAIN_MESSAGE);
        }
    };

    return (
        <>
            {
                (successMessageHeader && successMessageDescription) && <Toast
                    type='success'
                    header={successMessageHeader}
                    message={successMessageDescription}
                    onClose={resetSuccessMessages}
                />
            }
            {
                (errorMessageHeader && errorMessageDescription) && <Toast
                    type='error'
                    header={errorMessageHeader}
                    message={errorMessageDescription}
                    onClose={resetErrorMessages}
                />
            }
            {isLoading && <Loader></Loader>}
            {/* <div className='fab-profile-section-jp'> */}
            <>
                <p className='fab-profile-section-header'>Job preference</p>
                <div className='fab-profile-section-jp-container'>
                    <p className='fab-profile-section-field-header'>Availability</p>
                    <div className='fab-profile-section-checkmark-container'>
                        <div className='fab-profile-section-checkmark-wrapper'>
                            <input type='checkbox' className='fab-profile-section-checkmark-checkbox' checked={startWorkAnytime} onChange={handleStartWorkAnytimeChange} />
                            <p className='fab-profile-section-checkmark-header'>I can start work anytime</p>
                        </div>
                        <label className='fab-profile-section-checkmark-desc-container'>
                            <p className='fab-profile-section-checkmark-desc-text'>
                                This will automatically turned OFF every week.
                                <br></br>
                                Turn it ON to keep employer informed of your availability.
                            </p>
                        </label>
                    </div>
                    <div className='fab-profile-section-checkmark-container'>
                        <div className='fab-profile-section-checkmark-wrapper'>
                            <input type='checkbox' className='fab-profile-section-checkmark-checkbox' checked={inviteToApply} onChange={handleInviteToApplyChange} />
                            <p className='fab-profile-section-checkmark-header'>Invite to apply</p>
                        </div>
                        <label className='fab-profile-section-checkmark-desc-container'>
                            <p className='fab-profile-section-checkmark-desc-text'>
                                Allow employers to search for my profile and invite me to apply for their jobs via FastJobs.
                                <br></br>
                                <b>Note:</b> Personal information will not be made available to employer during search.
                            </p>
                        </label>
                    </div>
                </div>
                <div className='fab-profile-section-jp-container'>
                    <p className='fab-profile-section-field-header'>Select your preferred job type(s)</p>
                    <div className='fab-profile-section-checkmark-container'>
                        <div className='fab-profile-section-checkmark-wrapper'>
                            <input type='checkbox' className='fab-profile-section-checkmark-checkbox' checked={partTime} onChange={handlePartTimeChange} />
                            <p className='fab-profile-section-checkmark-header'>Part time</p>
                        </div>
                    </div>
                    <div className='fab-profile-section-checkmark-container'>
                        <div className='fab-profile-section-checkmark-wrapper'>
                            <input type='checkbox' className='fab-profile-section-checkmark-checkbox' checked={fullTime} onChange={handleFullTimeChange} />
                            <p className='fab-profile-section-checkmark-header'>Full time</p>
                        </div>
                    </div>
                    <div className='fab-profile-section-checkmark-container'>
                        <div className='fab-profile-section-checkmark-wrapper'>
                            <input type='checkbox' className='fab-profile-section-checkmark-checkbox' checked={contract} onChange={handleContractChange} />
                            <p className='fab-profile-section-checkmark-header'>Contract</p>
                        </div>
                    </div>
                </div>
                <div className='fab-profile-section-exp-sal-container'>
                    <p className='fab-profile-section-field-header'>Expected salary</p>
                    <div className='fab-sal-input'>
                        <div className='fab-sal-amount-input'>
                            <div className='fab-currency-group'>
                                <div className='fab-currency-group-base'>
                                    <svg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                        <path d='M5.048 11.956C5.61333 11.8813 6.04 11.692 6.328 11.388C6.62133 11.0787 6.768 10.676 6.768 10.18C6.768 9.97733 6.73067 9.80133 6.656 9.652C6.58667 9.49733 6.48533 9.36133 6.352 9.244C6.224 9.12667 6.072 9.02533 5.896 8.94C5.72 8.85467 5.528 8.77467 5.32 8.7L5.048 11.956ZM4.536 3.5C4.23733 3.53733 3.984 3.60133 3.776 3.692C3.568 3.77733 3.39733 3.884 3.264 4.012C3.13067 4.14 3.032 4.284 2.968 4.444C2.90933 4.604 2.88 4.772 2.88 4.948C2.88 5.15067 2.91467 5.32933 2.984 5.484C3.05867 5.63333 3.15733 5.76933 3.28 5.892C3.408 6.00933 3.55733 6.116 3.728 6.212C3.89867 6.30267 4.08533 6.388 4.288 6.468L4.536 3.5ZM5.472 6.852C5.856 6.96933 6.23733 7.1 6.616 7.244C6.99467 7.38267 7.33333 7.564 7.632 7.788C7.936 8.012 8.18133 8.292 8.368 8.628C8.55467 8.95867 8.648 9.37467 8.648 9.876C8.648 10.372 8.56533 10.8387 8.4 11.276C8.23467 11.708 7.992 12.092 7.672 12.428C7.352 12.7587 6.96 13.0307 6.496 13.244C6.032 13.452 5.50133 13.5747 4.904 13.612L4.808 14.788C4.80267 14.9107 4.74933 15.0227 4.648 15.124C4.552 15.2307 4.42933 15.284 4.28 15.284H3.552L3.696 13.572C3.072 13.4867 2.48533 13.316 1.936 13.06C1.38667 12.804 0.92 12.4867 0.536 12.108L1.144 11.204C1.19733 11.124 1.26667 11.06 1.352 11.012C1.44267 10.9587 1.53867 10.932 1.64 10.932C1.75733 10.932 1.88267 10.9747 2.016 11.06C2.14933 11.14 2.30133 11.236 2.472 11.348C2.64267 11.4547 2.83733 11.564 3.056 11.676C3.27467 11.788 3.53333 11.8707 3.832 11.924L4.128 8.348C3.74933 8.24133 3.37333 8.116 3 7.972C2.632 7.828 2.29867 7.63867 2 7.404C1.70667 7.164 1.46933 6.86267 1.288 6.5C1.10667 6.13733 1.016 5.684 1.016 5.14C1.016 4.73467 1.096 4.34 1.256 3.956C1.416 3.56667 1.65067 3.22 1.96 2.916C2.27467 2.612 2.65867 2.36133 3.112 2.164C3.56533 1.96667 4.08533 1.85467 4.672 1.828L4.76 0.82C4.77067 0.691999 4.824 0.577333 4.92 0.476C5.016 0.374666 5.14133 0.323999 5.296 0.323999H6.024L5.896 1.892C6.46133 1.98267 6.94933 2.14533 7.36 2.38C7.77067 2.60933 8.12533 2.868 8.424 3.156L7.944 3.884C7.87467 3.99067 7.80267 4.07067 7.728 4.124C7.65333 4.17733 7.56267 4.204 7.456 4.204C7.376 4.204 7.28 4.18 7.168 4.132C7.056 4.07867 6.93067 4.01733 6.792 3.948C6.65333 3.87333 6.496 3.79867 6.32 3.724C6.14933 3.64933 5.96 3.588 5.752 3.54L5.472 6.852Z' fill='#3F3F46' />
                                    </svg>
                                </div>
                            </div>
                            <div className='fab-amount-group'>
                                <input type='number' className='fab-amount-group-base fab-amount-input' placeholder='0' defaultValue={expectedSalary} value={expectedSalary} onChange={handleExpectedSalaryChange} />
                            </div>
                        </div>
                        <div className='fab-per-container'>
                            <p className='fab-per'>per</p>
                            <div className='fab-dropdown'>
                                <Select
                                    options={codeTableExpectedSalaryPerOptions}
                                    isMulti={false}
                                    getOptionValue={(option) => option.val}
                                    getOptionLabel={(option) => option.val}
                                    placeholder='Please select'
                                    onChange={handleExpectedSalaryPerChange}
                                    value={selectedExpectSalaryPer}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='fab-marketing-info-cb-container'>
                    <input type='checkbox' className='fab-marketing-info-cb' checked={pdpa} onChange={handlePdpaChange} />
                    <label className='fab-marketing-info-note'>
                        I wish to receive marketing information from FastJobs and/or service providers on products or services offered by FastJobs or other parties.
                    </label>
                </div>
                <div className='fab-profile-section-update-button-container'>
                    <Button className={`fab-profile-section-update-button ${enableUpdateChangesBtn ? '' : 'fab-profile-section-update-button-disable'}`} onClick={handleUpdateChanges} isDisabled={!enableUpdateChangesBtn}>
                        <p className='fab-profile-section-update-button-text'>Update changes</p>
                    </Button>
                </div>
                {/* </div> */}
            </>
        </>
    )
}

export default JobPreference;
